module.exports = __webpack_public_path__ + "img/1.905be3cc.jpg";